export enum PillColor {
  Black = 'black',
  Slate = 'slate',
  Blue = 'blue',
  Sky = 'sky',
  Cyan = 'cyan',
  Teal = 'teal',
  Green = 'green',
  Lime = 'lime',
  Yellow = 'yellow',
  Orange = 'orange',
  Red = 'red',
  Rose = 'rose',
  Pink = 'pink',
  Purple = 'purple',
  Indigo = 'indigo',
  Gray = 'gray',
}

export enum PillAppearance {
  Primary = 'primary',
  Secondary = 'secondary',
}
